import React from 'react'
import { Modal } from 'antd'
import style from './index.modules.scss'

const AnnouncementModal = (
  { visible, onCancel }: { visible: boolean, onCancel: () => void }
) => {
  return (
    <Modal
      className={style.announcementModal}
      title='系统维护公告'
      open={visible}
      onCancel={onCancel}
      width={1200}
      footer={null}
    >
      {/* <div className='section-title'>尊敬的用户：</div> */}
      <p>为了给您提供更稳定、高效的服务，我们将对云盯360平台的基础设施进行停机维护升级，以优化系统性能、提升您的使用体验。请您提前安排相关业务操作，以免受到影响。</p>

      <div>
        <div className={style.sectionTitle}>一、维护时间安排</div>
        <p>本次维护将分两个阶段进行，具体安排如下：</p>
        <ul className={style.listLevel1}>
          <li><strong>阶段一：(已完成)</strong>
            <ul className={style.listLevel2}>
              <li><strong>维护时段：</strong>2025年11月27日（周四）00:00 - 06:00</li>
              <li><strong>停机时段：</strong>2025年11月27日（周四）00:00 - 03:00</li>
              <li>在<strong>停机时段（00:00-03:00）</strong>内，系统将无法访问。03:00至06:00期间系统可正常使用，但我们会进行不影响使用的后台优化。</li>
            </ul>
          </li>
          <li><strong>阶段二：</strong>
            <ul className={style.listLevel2}>
              <li><strong>维护时段：</strong>2025年12月4日（周四）00:00 - 06:00</li>
              <li><strong>停机时段：</strong>2025年12月4日（周四）00:00 - 03:00</li>
              <li>在<strong>停机时段（00:00-03:00）</strong>内，系统将无法访问。03:00至06:00期间系统可正常使用，但我们可能继续进行不影响使用的后台优化。</li>
            </ul>
          </li>
        </ul>
      </div>

      <div>
        <div className={style.sectionTitle}>二、影响范围</div>
        <p>在<strong>上述停机时段（00:00-03:00）</strong>内，以下服务将暂时不可用：</p>
        <ul className={style.listLevel1}>
          <li>Web控制台</li>
          <li>移动端APP</li>
          <li>OpenAPI接口（调用将失败）</li>
          <li>数据同步工具（同步任务将中断）</li>
        </ul>
        <div className={style.tip}>
          <strong>温馨提示：</strong>对于OpenAPI接口取数和数据同步工具，我们建议您在停机维护结束后，进行手动重试或等待其自动重试机制恢复运行。
        </div>
      </div>

      <div>
        <div className={style.sectionTitle}>三、重要提醒：IP地址变更及白名单设置</div>
        <p>本次维护升级完成后，<strong>云平台的IP地址将发生变更</strong>，但域名保持不变。</p>
        <p>如果您或您的网络管理员为保障访问安全，设置了<strong>IP白名单</strong>，请务必在<strong>2025年12月4日0点前</strong>，将以下<strong>4个新的IP地址</strong>添加到您的白名单策略中，以免影响维护后对平台的正常访问。</p>

        <div className={style.sectionTitle}>【新增IP白名单列表】</div>
        <div>
          <ul className={style.listLevel1}>
            <li>43.144.171.150、49.232.113.26、49.232.26.8、43.138.104.147</li>
          </ul>
        </div>
      </div>

      <div>
        <div className={style.sectionTitle}>四、建议与支持</div>
        <ul>
          <li>请根据上述维护时间，提前安排好您的数据操作和业务流程，避免在维护时段进行关键操作。</li>
          <li>如有任何疑问，您可以通过以下方式联系我们：
            <ul>
              <li>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客服热线：<strong>4008-400-360</strong></li>
            </ul>
          </li>
        </ul>
      </div>

      <p>对于此次维护给您带来的不便，我们深表歉意！同时也感谢您的理解与支持。我们将竭尽全力缩短维护时间，确保升级顺利进行。此次升级将为后续更优质的服务体验奠定坚实基础。</p>
    </Modal>
  )
}

export default AnnouncementModal